<template>
  <transition name="modal-fade">
    <div @click.self="close"  class="modal-backdrop" >
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription">
        <div class="modal-container" id="modalContainer">
          <div @click="close" class="wrap-back-button">
            <span>
              Close
            </span>
          </div>
          <h3>Personal info</h3>
          <p v-html="`${person.personData.firstname} ${person.personData.name}`"/>
          <p> {{ person.personData.information }}</p>
          <h3>Filmography</h3>
          <ul>
            <li v-for="item in person.movies" :key="item"><a @click="goToMovie(item.uid)">{{ `${item.title_en} (${item.title_de})` }}</a></li>
          </ul>
          <div @click="close" class="wrap-back-button">
            <span>
              Close
            </span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  // Gleicher Aufbau wie im Modal -> Erklärung: siehe Modal
  name: 'Modal',
  data() {
    return {
      person: this.$store.state.person,
    };
  },
  methods: {
    async goToMovie(id) {
      await this.$store.commit('updateSelectedFilmCard', id);
      await this.$store.commit('updateSelectedPersonCard', 0);
      this.$router.push({ path: this.$store.state.site, query: { show: id } });
    },
    close() {
      this.$store.commit('updateSelectedPersonCard', 0);
      this.$router.push({ path: this.$store.state.site, query: { show: this.$store.state.selectedFilmCard } });
    },
  },

};
</script>
